import type { FC } from 'react';

import { Helpers } from '../../../../../../utility/helpers';
import type { PriceData, PriceType } from '../../../../../common/models/priceData/priceData';
import ProductDetailHeading from './ProductDetailHeading';

interface ProductPriceHistoryProps {
    priceHistory: PriceData;
    priceType: PriceType;
}

const ProductPriceHistory: FC<React.PropsWithChildren<ProductPriceHistoryProps>> = (props) => {
    return (
        <>
            <ProductDetailHeading>
                Tidigare lägsta pris:{' '}
                {Helpers.toEcommercePriceWithCurrency(
                    Helpers.getPrice(props.priceHistory, props.priceType),
                )}
            </ProductDetailHeading>
            <div>
                Tidigare lägsta pris är det lägsta pris som tillämpats för varan under de senaste 30
                dagarna innan den nuvarande kampanjen började.
            </div>
        </>
    );
};

export default ProductPriceHistory;
